import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import AdminPanel from './components/AdminPanel';
import AdvertsPage from './components/AdvertsPage';
import CompanyAuth from './components/CompanyAuth';
import ApplyPage from './components/ApplyPage';
import './styles.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<AdvertsPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin-dashboard" element={<AdminPanel />} /> {/* Added route for admin-dashboard */}
          <Route path="/company-auth" element={<CompanyAuth />} />
          <Route path="/apply" element={<ApplyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;